export const selectProductType = (state) => state.product.product;
